import type { SceneObject } from '@/types/scene'

type SceneStoreLike = {
  activeObjects: () => SceneObject[]
  updateObject: (id: string, patch: Partial<SceneObject>) => void
  updateObjectParams: (id: string, params: Record<string, unknown>) => void
  createGroup: (memberIds: string[], name?: string) => string | null
  ungroupByObjectIds: (ids: string[]) => void
}

/** 按对象类型写入 wallColor 或 color */
export function uniformColorForObjectIds(
  sceneStore: SceneStoreLike,
  ids: string[],
  color: string
): void {
  for (const id of ids) {
    const target = sceneStore.activeObjects().find((o) => o.id === id)
    if (!target) continue
    const key = target.params?.wallColor !== undefined ? 'wallColor' : 'color'
    sceneStore.updateObjectParams(id, { [key]: color })
  }
}

export function setLockedForObjectIds(
  sceneStore: SceneStoreLike,
  ids: string[],
  locked: boolean
): void {
  for (const id of ids) {
    sceneStore.updateObject(id, { locked })
  }
}

/** 批量开关物体顶部名称标签（保留已有文字与样式） */
export function setTopLabelVisibleForObjectIds(
  sceneStore: SceneStoreLike,
  ids: string[],
  visible: boolean
): void {
  for (const id of ids) {
    const target = sceneStore.activeObjects().find((o) => o.id === id)
    if (!target) continue
    const cur = target.label ?? { text: '', visible: false }
    sceneStore.updateObject(id, { label: { ...cur, visible } })
  }
}

/** 批量开关状态指示标签 */
export function setStatusLightEnabledForObjectIds(
  sceneStore: SceneStoreLike,
  ids: string[],
  enabled: boolean
): void {
  for (const id of ids) {
    const target = sceneStore.activeObjects().find((o) => o.id === id)
    if (!target) continue
    const cur = target.statusLight ?? { enabled: false, color: 'gray' as const, label: '' }
    sceneStore.updateObject(id, {
      statusLight: { ...cur, enabled, label: enabled ? cur.label || '未知' : cur.label },
    })
  }
}

/** 批量开关物体信息卡（保留已有字段与绑定；仅切换 enabled，不破坏 fields） */
export function setInfoCardEnabledForObjectIds(
  sceneStore: SceneStoreLike,
  ids: string[],
  enabled: boolean
): void {
  for (const id of ids) {
    const target = sceneStore.activeObjects().find((o) => o.id === id)
    if (!target) continue
    const cur = target.infoCard ?? { enabled: false, fields: [] }
    sceneStore.updateObject(id, { infoCard: { ...cur, enabled } })
  }
}

export function groupObjectIds(sceneStore: SceneStoreLike, ids: string[]): string | null {
  const unique = Array.from(new Set(ids))
  return sceneStore.createGroup(unique)
}

export function ungroupObjectIds(sceneStore: SceneStoreLike, ids: string[]): void {
  sceneStore.ungroupByObjectIds([...ids])
}
